import {
  FaFacebookSquare,
  FaInstagram,
  FaLinkedin,
  FaTelegram,
} from "react-icons/fa";
import React from "react";
import { Link } from "react-router-dom";

export const NFooter = () => {
  return (
    <>
      <footer className="bg-dark text-white pt-5">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-8">
              <h3>
                <Link
                  className="text-light "
                  to="/"
                  style={{ fontWeight: "bold" }}
                >
                  WDSchool
                </Link>
              </h3>
              <h3 style={{ textAlign: "center" }}>NodeJs Tutorial</h3>
              <hr />
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-6">
                    <h3 style={{ textAlign: "center" }}>NodeJs</h3>
                    <hr />
                    <ul className=" text-secondary table">
                      <li>
                        {" "}
                        <Link to="/NodeFirstStep">NodeJs – First Step</Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="/NodeModules">Node.js Modules</Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="/NodeHttpModules">Node.js HTTP Module</Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="/DataType">Node.js File System Module</Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="/Operators">Node.js URL Module</Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="/Input">Node.js NPM</Link>
                      </li>
                      {/* <li>
                          {" "}
                          <Link to="">Python – Print</Link>
                        </li> */}
                      <li>
                        {" "}
                        <Link to="/DecisionMaking">Node.js Events</Link>
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <h3 style={{ textAlign: "center" }}>NodeJs With MongoDB</h3>
                    <hr />
                    <ul className=" text-secondary table">
                      <li>
                        {" "}
                        <Link to="">Node.js MongoDB Create Database</Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="">Node.js MongoDB Create Collection</Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="">Node.js MongoDB Insert</Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="">Node.js MongoDB Find</Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="">Node.js MongoDB Query</Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="">Node.js MongoDB Sort</Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="">Node.js MongoDB Delete</Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="">Node.js MongoDB Update</Link>
                      </li>
                    </ul>
                  </div>
                  {/* <div className="col-md-4">
                    <ul className=" text-secondary table">
                      <li>
                        {" "}
                        <Link to="">Function in Python</Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="">Module in Python</Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="">Python Exception Handling</Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="">Python File Handling</Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="">
                          Python OOPS – Object Oriented Programming System
                        </Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="">className and Object in Python</Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="">Inheritance in Python</Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="">Python Database Connection</Link>
                      </li>
                    </ul>
                  </div> */}
                </div>
              </div>
            </div>
            {/* <div className="col-md-2"></div> */}
            <div className="col-md-4">
              <h3 style={{ marginLeft: "90px" }}>
                Web Development<span className="text-primary"> School</span>
              </h3>

              <ul className="list-unstyled text-secondary  text-md-end mt-5">
                <li>SECTOR 16,NOIDA - SOUTH EX. - PITAMPURA - GURUGRAM</li>
                <li>
                  WDSchool:{" "}
                  <span className="text-primary">99-10-93-50-66 </span>
                </li>
                <li>
                  {" "}
                  Learn Coding With{" "}
                  <span className="text-primary">Rahul Katoch</span>{" "}
                </li>
              </ul>
            </div>
          </div>
          <hr />

          <div className="row">
            <div className="col-md-3 mt-5">
              <h2> Request a Call Back</h2>
              <h3 className="text-primary"> 99-10-93-50-66</h3>
            </div>
            <div className="col-md-5 mt-4 d-flex flex-column justify-content-center align-items-center">
              <p className="bg-primary pt-1"> Follow Us </p>
              <div style={{ fontFamily: "sans-serif", textAlign: "center" }}>
                <a href="https://www.facebook.com/rahul.katoch.9231">
                  <FaFacebookSquare />
                </a>

                <a
                  href="https://www.instagram.com/official_rahulkatoch/?igshid=YmMyMTA2M2Y%3D"
                  style={{ paddingLeft: "12px" }}
                >
                  <FaInstagram />
                </a>

                <a
                  href="www.linkedin.com/in/rahul-katoch-088a7b206"
                  style={{ paddingLeft: "12px" }}
                >
                  <FaLinkedin />
                </a>

                <a href="" style={{ paddingLeft: "12px" }}>
                  <FaTelegram />
                </a>
              </div>
            </div>

            <div className="col-md-4 mt-5">
              <img
                className="img-fluid"
                src="https://www.kindpng.com/picc/m/48-480088_payment-method-credit-card-master-card-hd-png.png"
                alt=""
              />
            </div>
          </div>
          <br />
          <div className="copyright  bg-primary py-4 mt-2">
            <div className="container">
              <div className="row">
                <div className="col-md-6">
                  <small>
                    Privacy Policy || Terms of Use || Career || Blog
                  </small>
                </div>
                <div className="col-md-6">
                  <small>
                    © Copyright 2022 Rahul Katoch , All rights reserved.
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};
